import { render, staticRenderFns } from "./SPRPortrait.vue?vue&type=template&id=54689c6c&scoped=true"
import script from "./SPRPortrait.vue?vue&type=script&lang=js"
export * from "./SPRPortrait.vue?vue&type=script&lang=js"
import style0 from "./SPRPortrait.vue?vue&type=style&index=0&id=54689c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54689c6c",
  null
  
)

export default component.exports